import { Grid } from '@mui/material'
import { MonetizationOn } from '@mui/icons-material'
import { DatePicker } from '@mui/x-date-pickers'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { inject } from 'mobx-react'
import moment, { Moment } from 'moment'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import ESDataTableWithHeader from '../common/ESDataTableWithHeader'
import IDataTableManager from '../common/IDataTableManager'
import ResponsiveAppBar from '../common/ResponsiveAppBar'
import { DefaultMedicareCostLookup, IMedicareCostLookup } from '../Definitions'
import { IStores } from '../Stores'
import MedicareCostLookupDialog from './MedicareCostLookupDialog'

interface IMedicareCostLookupsProps {
  clearFilters?: () => void
  dataTableManager?: IDataTableManager<IMedicareCostLookup>
  disableMedicareCostLookup?: (medicareCostLookup: IMedicareCostLookup) => void
  getColumnSettingsAndMedicareCostLookups?: () => void
  isModalOpen?: boolean
  openDialogWithMedicareCostLookup?: (medicareCostLookup: IMedicareCostLookup) => void
  recoverMedicareCostLookup?: (medicareCostLookup: IMedicareCostLookup) => void
  selectedDate?: Date
  setSelectedDate?: (date: Date | null) => void
}

@inject((stores: IStores) => ({
  clearFilters: stores.medicareCostLookups.clearFilters,
  dataTableManager: stores.medicareCostLookups.dataTableStore,
  disableMedicareCostLookup: stores.medicareCostLookups.disableMedicareCostLookup,
  getColumnSettingsAndMedicareCostLookups:
    stores.medicareCostLookups.getColumnSettingsAndMedicareCostLookups,
  isModalOpen: stores.medicareCostLookups.isModalOpen,
  openDialogWithMedicareCostLookup:
    stores.medicareCostLookups.openDialogWithMedicareCostLookup,
  recoverMedicareCostLookup: stores.medicareCostLookups.recoverMedicareCostLookup,
  selectedDate: stores.medicareCostLookups.selectedDate,
  setSelectedDate: stores.medicareCostLookups.setSelectedDate,
}))
class MedicareCostLookups extends React.Component<IMedicareCostLookupsProps> {
  public componentDidMount() {
    this.props.getColumnSettingsAndMedicareCostLookups!()
  }

  public componentWillUnmount() {
    this.props.clearFilters!()
  }

  public render() {
    const medicareCostLookupDialog = this.props.isModalOpen && (
      <MedicareCostLookupDialog />
    )
    return (
      <>
        <Helmet>
          <title>Medicare Cost</title>
        </Helmet>
        <ResponsiveAppBar title="Medicare Cost" pageIcon={<MonetizationOn />} />
        <ESDataTableWithHeader
          dataTableManager={this.props.dataTableManager!}
          enableSearch={true}
          enableShowInactives={true}
          addButtonOnClick={this.openDialog(DefaultMedicareCostLookup(true))}
          filterComponents={this.getFilters()}
        />
        {medicareCostLookupDialog}
      </>
    )
  }

  private getFilters = () => {
    return (
      <Grid item xs={12}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            value={this.props.selectedDate ? moment(this.props.selectedDate) : null}
            format="MM/DD/YYYY"
            onChange={this.onDateChange()}
          />
        </LocalizationProvider>
      </Grid>
    )
  }

  private onDateChange = () => (date: Moment | null) => {
    this.props.setSelectedDate!(date ? date.toDate() : null)
  }

  public openDialog = (medicareCostLookup: IMedicareCostLookup) => () => {
    this.props.openDialogWithMedicareCostLookup!(medicareCostLookup)
  }
}

export default MedicareCostLookups
